import { CollectionInsightType } from '@components/collections/Model';

const requireAllPgLoadedInCollectionsByInsightType: Partial<Record<CollectionInsightType, boolean>> = {
  //Explore - Trends
  [CollectionInsightType.TrendStackBarChart]: false,
  [CollectionInsightType.ExploreLineChart]: false,
};

export const getRequireAllPgLoadedInCollections = (insightType: CollectionInsightType): boolean => {
  return requireAllPgLoadedInCollectionsByInsightType[insightType] ?? true;
};
